import * as tslib_1 from "tslib";
import { PagedResult } from '@interfaces';
import { Apollo } from 'apollo-angular';
import { Queries } from './queries';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./queries";
var PendenciesService = /** @class */ (function () {
    function PendenciesService(apollo, queries) {
        this.apollo = apollo;
        this.queries = queries;
    }
    PendenciesService.prototype.getPendencies = function (options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: this.queries.getPendencies(),
                        variables: options
                    })
                        .toPromise()
                        .then(function (response) { return response.data['pendencies']; })];
            });
        });
    };
    PendenciesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PendenciesService_Factory() { return new PendenciesService(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.Queries)); }, token: PendenciesService, providedIn: "root" });
    return PendenciesService;
}());
export { PendenciesService };
